import TabViewList, { getImperativeHandleParamsForTabViewList } from './TabViewList';
import type { CommonTabViewListProps as CommonTabViewList } from './TabViewList';

export type CommonTabViewListProps = CommonTabViewList;
export { getImperativeHandleParamsForTabViewList };
export default TabViewList;
